// extracted by mini-css-extract-plugin
module.exports = {"label":"PlanUnitOption_label__P0E7M","icon":"PlanUnitOption_icon__38KWj"};